import { DEMO_BUILD } from 'constants/env';

export function isDemoBuild() {
  return DEMO_BUILD === 'true';
}
